/* CARLUEX V1 landing product page（2026-09-23）
   星空画布 / 进场渐显 / 视频懒加载自动播放 / 客户视频墙自动滑动 / 车系 chip / 车型表单 + fitment 校验 + 加购 */
(() => {
  const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const rand = (a, b) => a + Math.random() * (b - a);

  /* ---------- 星空 ---------- */
  const SKY = { areaPerStar: 5200, starMinSize: 0.4, starMaxSize: 1.5, twinkleMin: 2.5, twinkleMax: 6,
    meteorGapMin: 2.2, meteorGapMax: 5.5, meteorSpeed: 1100, meteorTailMin: 140, meteorTailMax: 260, meteorLife: 0.9,
    meteorAngleMin: 28, meteorAngleMax: 42, maxDpr: 2 };

  const startSky = (page) => {
    const sky = page.querySelector('.cvl-sky'); const canvas = page.querySelector('[data-cvl-sky]');
    if (!sky || !canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    const still = reduced();
    const meteorCanvas = document.createElement('canvas'); meteorCanvas.className = 'cvl-sky__meteor'; sky.appendChild(meteorCanvas);
    const mctx = meteorCanvas.getContext('2d');
    let w = 0, h = 0, dpr = 1, raf = 0, inView = true, meteor = null, spawnTimer = 0, twinklers = [], lastTw = 0;

    const bake = () => {
      const count = Math.min(420, Math.round((w * h) / SKY.areaPerStar));
      ctx.clearRect(0, 0, w, h); ctx.fillStyle = '#ffffff';
      twinklers = [];
      for (let i = 0; i < count; i++) {
        const x = Math.random() * w, y = Math.random() * h, r = rand(SKY.starMinSize, SKY.starMaxSize), base = rand(0.35, 0.9);
        if (!still && i % 5 === 0) {
          twinklers.push({ x, y, r, base, freq: (Math.PI * 2) / rand(SKY.twinkleMin, SKY.twinkleMax), phase: Math.random() * Math.PI * 2 });
        } else {
          ctx.globalAlpha = base * 0.85; ctx.beginPath(); ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
    };
    const resize = () => {
      dpr = Math.min(window.devicePixelRatio || 1, SKY.maxDpr);
      w = window.innerWidth; h = window.innerHeight;
      for (const c of [canvas, meteorCanvas]) { c.width = Math.round(w * dpr); c.height = Math.round(h * dpr); c.style.width = w + 'px'; c.style.height = h + 'px'; }
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0); mctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      bake();
    };
    const drawTwinkle = (now) => {
      const t = now / 1000; mctx.fillStyle = '#ffffff';
      for (const s of twinklers) { mctx.globalAlpha = s.base * (0.6 + 0.4 * Math.sin(t * s.freq + s.phase)); mctx.beginPath(); mctx.arc(s.x, s.y, s.r, 0, Math.PI * 2); mctx.fill(); }
      mctx.globalAlpha = 1;
    };
    const drawMeteor = (now) => {
      mctx.clearRect(0, 0, w, h);
      drawTwinkle(now);
      if (!meteor) return;
      const age = (now - meteor.born) / 1000, life = age / (meteor.life || SKY.meteorLife);
      if (life >= 1) { meteor = null; return; }
      const alpha = meteor.aimed ? 1 : life < 0.2 ? life / 0.2 : 1 - (life - 0.2) / 0.8;
      const hx = meteor.x + meteor.vx * age, hy = meteor.y + meteor.vy * age, len = Math.hypot(meteor.vx, meteor.vy);
      const tx = hx - (meteor.vx / len) * meteor.tail, ty = hy - (meteor.vy / len) * meteor.tail;
      const g = mctx.createLinearGradient(hx, hy, tx, ty);
      g.addColorStop(0, `rgba(255,255,255,${0.95 * alpha})`); g.addColorStop(0.25, `rgba(200,220,255,${0.5 * alpha})`); g.addColorStop(1, 'rgba(200,220,255,0)');
      mctx.strokeStyle = g; mctx.lineWidth = meteor.aimed ? 2.4 : 1.6; mctx.lineCap = 'round';
      mctx.beginPath(); mctx.moveTo(hx, hy); mctx.lineTo(tx, ty); mctx.stroke();
      mctx.globalAlpha = alpha; mctx.fillStyle = '#ffffff'; mctx.beginPath(); mctx.arc(hx, hy, 1.6, 0, Math.PI * 2); mctx.fill(); mctx.globalAlpha = 1;
    };
    const frame = (now) => { if (meteor || now - lastTw >= 83) { drawMeteor(now); lastTw = now; if (!meteor && spawnTimer === 0) scheduleMeteor(); } raf = requestAnimationFrame(frame); };
    const spawnMeteor = () => {
      if (still || !inView || document.hidden) return;
      const angle = (rand(SKY.meteorAngleMin, SKY.meteorAngleMax) * Math.PI) / 180;
      meteor = { x: rand(w * 0.3, w * 1.1), y: rand(-h * 0.05, h * 0.45), vx: -Math.cos(angle) * SKY.meteorSpeed, vy: Math.sin(angle) * SKY.meteorSpeed, tail: rand(SKY.meteorTailMin, SKY.meteorTailMax), born: performance.now() };
      spawnTimer = 0;
    };
    const scheduleMeteor = () => { clearTimeout(spawnTimer); if (still) return; spawnTimer = setTimeout(spawnMeteor, rand(SKY.meteorGapMin, SKY.meteorGapMax) * 1000); };
    const aimMeteor = (tx, ty, life) => {
      const angle = (STRIKE.angleDeg * Math.PI) / 180, vx = -Math.cos(angle) * STRIKE.speed, vy = Math.sin(angle) * STRIKE.speed;
      clearTimeout(spawnTimer); spawnTimer = 0;
      meteor = { x: tx - vx * life, y: ty - vy * life, vx, vy, tail: STRIKE.tail, life, aimed: true, born: performance.now() };
      if (!raf) raf = requestAnimationFrame(frame);
    };
    const stop = () => { cancelAnimationFrame(raf); raf = 0; clearTimeout(spawnTimer); spawnTimer = 0; meteor = null; mctx.clearRect(0, 0, w, h); };
    const start = () => {
      if (still || !inView || document.hidden || raf) return;
      scheduleMeteor();
      raf = requestAnimationFrame(frame);
    };
    page.addEventListener('cvl:aim', (e) => { if (!still) aimMeteor(e.detail.x, e.detail.y, e.detail.life); });

    resize(); start();
    let rt = 0; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(resize, 150); });
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    new IntersectionObserver(([e]) => { inView = e.isIntersecting; inView ? start() : stop(); }).observe(page);
  };

  /* ---------- 首屏圆形播放器 ---------- */
  const prepareBadge = (page) => {
    const readies = [];
    page.querySelectorAll('[data-cvl-badge]').forEach((box) => {
      let list = [];
      try { list = JSON.parse(box.querySelector('[data-cvl-badge-list]')?.textContent || '[]').filter((x) => x && x.src); } catch (e) {}
      const vids = [...box.querySelectorAll('[data-cvl-badge-v]')];
      if (!list.length || vids.length < 2) return;
      readies.push(new Promise((res) => { vids[0].addEventListener('loadeddata', res, { once: true }); vids[0].addEventListener('error', res, { once: true }); }));
      vids.forEach((v) => { v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true; v.setAttribute('muted', ''); });
      const interval = Math.max(2, Number(box.dataset.interval) || 3) * 1000;
      let idx = 0, cur = 0, timer = 0, inView = false;
      const blobs = new Map();
      const resolveSrc = (src) => blobs.has(src) ? blobs.get(src) : (blobs.set(src, fetch(src).then((r) => r.ok ? r.blob() : Promise.reject()).then((b) => URL.createObjectURL(b)).catch(() => src)), blobs.get(src));
      const load = (v, item) => { v.poster = item.poster || ''; if (v.dataset.item === item.src) return; v.dataset.item = item.src; resolveSrc(item.src).then((u) => { if (v.dataset.item !== item.src) return; v.src = u; v.load(); if (v.classList.contains('is-on')) v.play().catch(() => {}); }); };
      const show = (v) => { v.classList.add('is-on'); v.play().catch(() => {}); };
      vids[0].poster = list[0].poster || ''; vids[0].classList.add('is-on');
      load(vids[0], list[0]); show(vids[0]);
      const bootNext = () => { if (list.length > 1) setTimeout(() => load(vids[1], list[1 % list.length]), 1200); };
      if (document.readyState === 'complete') bootNext(); else window.addEventListener('load', bootNext, { once: true });
      const next = () => {
        if (list.length < 2 || !inView || document.hidden) return;
        idx = (idx + 1) % list.length; const from = vids[cur], to = vids[1 - cur]; cur = 1 - cur;
        load(to, list[idx]);
        const go = () => { from.classList.add('is-out'); from.classList.remove('is-on'); setTimeout(() => { from.classList.remove('is-out'); show(to); setTimeout(() => { from.pause(); load(from, list[(idx + 1) % list.length]); }, 400); }, 240); };
        if (to.readyState >= 2) go(); else { const t = setTimeout(go, 2500); to.addEventListener('loadeddata', () => { clearTimeout(t); go(); }, { once: true }); }
      };
      const start = () => { clearInterval(timer); if (!reduced() && list.length > 1) timer = setInterval(next, interval); vids[cur].play().catch(() => {}); };
      const stop = () => { clearInterval(timer); vids.forEach((v) => v.pause()); };
      new IntersectionObserver(([e]) => { inView = e.isIntersecting; inView ? start() : stop(); }, { rootMargin: '100px' }).observe(box);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : inView && start()));
    });
    return Promise.all(readies);
  };

  /* ---------- 漂浮图案场 ---------- */
  const prepareFloat = (page) => {
    page.querySelectorAll('[data-cvl-float]').forEach((field) => {
      const all = [...field.querySelectorAll('[data-cvl-orb]')];
      if (!all.length) return;
      const readDesign = (el) => { const v = el.querySelector('video'); return { src: v.dataset.src || v.getAttribute('src') || '', poster: v.dataset.poster || v.getAttribute('poster') || '', label: el.querySelector('.cvl-orb__label')?.textContent || '' }; };
      const seen = new Set(); const designs = all.map(readDesign).filter((d) => { const k = d.src.split('?')[0]; if (!k || seen.has(k)) return false; seen.add(k); return true; });
      const setDesign = (el, d) => {
        const v = el.querySelector('video'); const attached = !!v.getAttribute('src');
        v.pause(); v.dataset.src = d.src; v.dataset.poster = d.poster; v.poster = d.poster;
        if (attached) { v.src = d.src; v.load(); v.play().catch(() => {}); } else v.removeAttribute('src');
        el.querySelector('.cvl-orb__label').textContent = d.label; v.setAttribute('aria-label', d.label);
      };
      let teardown = null;
      const build = () => {
      if (teardown) teardown();
      const still = reduced();
      const rand = (a, b) => a + Math.random() * (b - a);
      let W = field.clientWidth, H = field.clientHeight;
      const mobile = W < 640;
      const MAX = Math.min(designs.length, mobile ? 6 : W < 1024 ? 10 : 16);
      all.forEach((el) => { el.hidden = false; el.classList.remove('is-front', 'is-swap'); el.style.transform = ''; });
      const orbs = all.slice(0, MAX);
      orbs.forEach((el, i) => setDesign(el, designs[i]));
      const queue = designs.slice(MAX);
      all.slice(MAX).forEach((el) => { el.hidden = true; const v = el.querySelector('video'); if (v && v.getAttribute('src')) { v.pause(); v.removeAttribute('src'); v.load(); } });
      const n = orbs.length;
      const avgR = Math.sqrt(0.11 * W * H / (n * Math.PI));
      const base = Math.min(Math.max(avgR * 2 / 0.86, mobile ? 56 : 72), mobile ? 88 : 108);
      const depths = [1, .45, .8, .32, .9, .6, .4, .85, .5, .7, .3, .95, .55, .36, .75, .48, .88];
      const rOf = (d) => base * ((mobile ? 0.4 : 0.32) + (mobile ? 0.95 : 1.05) * d) / 2;
      const rMax = rOf(1);
      const state = orbs.map((el, i) => {
        const d = depths[i % depths.length];
        el.style.setProperty('--size', (rMax * 2).toFixed(1) + 'px');
        el.style.setProperty('--depth', d.toFixed(2));
        const speed = (mobile ? 24 : 40) * (0.6 + 0.6 * d);
        const ang = rand(0, Math.PI * 2);
        return { el, design: designs[i], d, d0: .45 + .35 * d, dA: rand(.22, .3), r: rOf(d), r0: rOf(d), grow: 1, x: 0, y: 0, vx: Math.cos(ang) * speed, vy: Math.sin(ang) * speed, speed, wander: rand(0, 6.28), bob: rand(0, 6.28), bobA: rand(3, 7), zf: rand(.17, .39), zp: rand(0, 6.28), front: false, swapping: false };
      });
      const place = () => {
        W = field.clientWidth; H = field.clientHeight;
        state.forEach((o, i) => {
          let ok = false, tries = 0;
          while (!ok && tries < 400) {
            tries++; const x = rand(o.r + 8, W - o.r - 8), y = rand(o.r + 8, H - o.r - 8);
            ok = state.slice(0, i).every((p) => Math.hypot(p.x - x, p.y - y) > (p.r + o.r) * (tries < 200 ? 1.15 : 1.02));
            if (ok) { o.x = x; o.y = y; }
          }
          if (!ok) { o.x = rand(o.r, W - o.r); o.y = rand(o.r, H - o.r); }
        });
      };
      place();
      let mx = -9999, my = -9999, inView = false, raf = 0, last = 0, px = 0, py = 0, tpx = 0, tpy = 0;
      field.addEventListener('pointermove', (e) => { if (e.pointerType !== 'mouse') return; const rc = field.getBoundingClientRect(); mx = e.clientX - rc.left; my = e.clientY - rc.top; tpx = mx / rc.width - .5; tpy = my / rc.height - .5; });
      field.addEventListener('pointerleave', () => { mx = -9999; my = -9999; tpx = 0; tpy = 0; });
      orbs.forEach((el, i) => {
        el.addEventListener('pointerenter', () => { state[i].front = true; el.classList.add('is-front'); });
        el.addEventListener('pointerleave', () => { state[i].front = false; el.classList.remove('is-front'); });
      });
      const swapOne = () => {
        if (!queue.length || !inView || document.hidden) return;
        const candidates = state.filter((o) => !o.front && !o.swapping);
        if (!candidates.length) return;
        const o = candidates[Math.floor(Math.random() * candidates.length)];
        const next = queue.shift(); queue.push(o.design); o.design = next;
        o.swapping = true; o.el.classList.add('is-swap');
        setTimeout(() => {
          setDesign(o.el, next); const v = o.el.querySelector('video'); if (!v.getAttribute('src')) { v.src = next.src; v.load(); v.play().catch(() => {}); }
          o.el.classList.remove('is-swap');
          setTimeout(() => { o.swapping = false; }, 600);
        }, 520);
      };
      let swapTimer = 0; if (queue.length && !still) swapTimer = setInterval(swapOne, 4000);
      const GROW = mobile ? 1.35 : 1.6;
      let tNow = 0;
      const stepPhysics = (dt) => {
        for (const o of state) {
          if (!o.front) o.d = Math.min(1, Math.max(.3, o.d0 + o.dA * Math.sin(tNow * o.zf + o.zp)));
          o.r0 = rOf(o.d); o.speed = (mobile ? 24 : 40) * (0.6 + 0.6 * o.d);
          const g = o.front ? GROW : 1; o.grow += (g - o.grow) * Math.min(1, dt * 9); o.r = o.r0 * o.grow;
        }
        for (const o of state) {
          if (o.front) continue;
          o.wander += rand(-1.2, 1.2) * dt;
          const turn = 0.35 * dt;
          const c = Math.cos(turn * Math.sin(o.wander)), sn = Math.sin(turn * Math.sin(o.wander));
          const vx = o.vx * c - o.vy * sn, vy = o.vx * sn + o.vy * c; o.vx = vx; o.vy = vy;
          const dxm = o.x - mx, dym = o.y - my, dm = Math.hypot(dxm, dym);
          if (dm < o.r + 90) { const f = (o.r + 90 - dm) * 2.2 * dt; o.vx += (dxm / dm) * f * 10; o.vy += (dym / dm) * f * 10; }
          const sp = Math.hypot(o.vx, o.vy) || 1; const k = 1 + (o.speed / sp - 1) * Math.min(1, dt * 1.5); o.vx *= k; o.vy *= k;
          o.x += o.vx * dt; o.y += o.vy * dt;
          if (o.x < o.r) { o.x = o.r; o.vx = Math.abs(o.vx); } if (o.x > W - o.r) { o.x = W - o.r; o.vx = -Math.abs(o.vx); }
          if (o.y < o.r) { o.y = o.r; o.vy = Math.abs(o.vy); } if (o.y > H - o.r) { o.y = H - o.r; o.vy = -Math.abs(o.vy); }
        }
        for (let i = 0; i < state.length; i++) for (let j = i + 1; j < state.length; j++) {
          const a = state[i], b = state[j]; const dx = b.x - a.x, dy = b.y - a.y; const dist = Math.hypot(dx, dy) || 0.01; const min = a.r + b.r + 10;
          if (dist < min) {
            const nx = dx / dist, ny = dy / dist, overlap = min - dist;
            const wa = a.front ? 0 : 1, wb = b.front ? 0 : 1, wsum = wa + wb || 1;
            a.x -= nx * overlap * (wa / wsum); a.y -= ny * overlap * (wa / wsum); b.x += nx * overlap * (wb / wsum); b.y += ny * overlap * (wb / wsum);
            const rel = (b.vx - a.vx) * nx + (b.vy - a.vy) * ny;
            if (rel < 0) { const imp = rel * .9; if (!a.front) { a.vx += nx * imp; a.vy += ny * imp; } if (!b.front) { b.vx -= nx * imp; b.vy -= ny * imp; } }
            if (a.front || b.front) { const kick = overlap * 6; if (!a.front) { a.vx -= nx * kick; a.vy -= ny * kick; } if (!b.front) { b.vx += nx * kick; b.vy += ny * kick; } }
          }
        }
      };
      const paint = (t) => {
        px += (tpx - px) * .06; py += (tpy - py) * .06;
        const rc = field.getBoundingClientRect(); const vh = window.innerHeight || 1;
        const scrollP = Math.max(-1, Math.min(1, ((rc.top + rc.height / 2) / vh - .5) * 2));
        for (const o of state) {
          const bob = still ? 0 : o.bobA * Math.sin(t * 1.1 + o.bob);
          const zs = o.r / rMax;
          const par = (o.d - 0.3) / 0.7;
          o.el.style.setProperty('--depth', o.d.toFixed(3)); o.el.style.zIndex = o.front ? 20 : Math.round(o.d * 10);
          const ox = -px * (10 + 70 * par) + 0, oy = -py * (6 + 40 * par) - scrollP * (8 + 46 * par);
          o.el.style.transform = `translate3d(${(o.x + ox).toFixed(1)}px, ${(o.y + bob + oy).toFixed(1)}px, 0) scale(${zs.toFixed(3)})`;
        }
      };
      const frame = (now) => { const t = now / 1000; tNow = t; if (last && !still) stepPhysics(Math.min(.05, t - last)); last = t; paint(t); raf = requestAnimationFrame(frame); };
      const start = () => { if (raf || !inView || document.hidden) return; last = 0; raf = requestAnimationFrame(frame); };
      const stop = () => { cancelAnimationFrame(raf); raf = 0; };
      const io = new IntersectionObserver(([e]) => { inView = e.isIntersecting; inView ? start() : stop(); }, { rootMargin: '100px' });
      io.observe(field);
      const onVis = () => (document.hidden ? stop() : start());
      document.addEventListener('visibilitychange', onVis);
      teardown = () => { stop(); io.disconnect(); document.removeEventListener('visibilitychange', onVis); if (swapTimer) clearInterval(swapTimer); };
      paint(0);
      };
      build();
      let lastW = field.clientWidth, rt = 0;
      window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(() => { const w = field.clientWidth; if (Math.abs(w - lastW) > 40) { lastW = w; build(); } }, 200); });
    });
  };

  /* ---------- 进场渐显 ---------- */
  const prepareReveals = (page) => {
    const items = page.querySelectorAll('.cvl-reveal');
    if (!('IntersectionObserver' in window) || reduced()) { items.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    items.forEach((el) => io.observe(el));
  };

  /* ---------- 视频懒加载 ---------- */
  const prepareVideos = (page) => {
    const videos = page.querySelectorAll('[data-cvl-video]');
    const attach = (el) => {
      if (el.dataset.poster && !el.getAttribute('poster')) el.poster = el.dataset.poster;
      if (el.dataset.src && !el.getAttribute('src')) el.src = el.dataset.src;
    };
    videos.forEach((el) => { el.muted = true; el.defaultMuted = true; el.loop = true; el.playsInline = true; el.setAttribute('muted', ''); el.dataset.wantPlay = ''; el.addEventListener('loadeddata', () => { if (el.dataset.wantPlay === '1' && el.paused) el.play().catch(() => {}); }); el.addEventListener('stalled', () => { if (el.dataset.wantPlay === '1') setTimeout(() => el.paused && el.play().catch(() => {}), 1500); }); });
    if (!('IntersectionObserver' in window)) { videos.forEach((el) => { attach(el); el.play().catch(() => {}); }); return; }
    const detach = (el) => {
      if (el.hasAttribute('data-eager') || !el.getAttribute('src')) return;
      if (!el.dataset.src) el.dataset.src = el.getAttribute('src');
      el.pause(); el.removeAttribute('src'); el.load();
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (entry.isIntersecting) attach(el); else detach(el);
        if (entry.intersectionRatio >= 0.25) { el.dataset.wantPlay = '1'; el.play().catch(() => {}); } else { el.dataset.wantPlay = '0'; el.pause(); }
      });
    }, { rootMargin: '250px', threshold: [0, 0.25] });
    videos.forEach((el) => io.observe(el));
  };

  /* ---------- 视频墙 ---------- */
  const prepareCarousels = (page) => {
    page.querySelectorAll('[data-cvl-carousel]').forEach((wrap) => {
      const row = wrap.querySelector('.cvl-row');
      if (!row || row.children.length < 2) return;
      const originals = [...row.children];
      if (!(window.Shopify && window.Shopify.designMode) && !wrap.hasAttribute('data-cvl-keep-order')) {
        for (let i = originals.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [originals[i], originals[j]] = [originals[j], originals[i]]; }
        originals.forEach((li) => row.appendChild(li));
      }
      originals.forEach((li) => {
        const clone = li.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true'); clone.dataset.clone = '1';
        clone.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
        clone.removeAttribute('data-shopify-editor-block');
        row.appendChild(clone);
      });
      const gap = () => parseFloat(getComputedStyle(row).columnGap) || 0;
      const loopWidth = () => originals.reduce((w, li) => w + li.offsetWidth, 0) + gap() * originals.length;
      const gutter = () => parseFloat(getComputedStyle(row).paddingLeft) || 0;
      let inView = false, pausedUntil = 0, hovering = false, animating = false, drag = null;
      new IntersectionObserver(([e]) => (inView = e.isIntersecting), { threshold: 0.3 }).observe(row);
      const normalize = () => { const L = loopWidth(); if (row.scrollLeft >= L) row.scrollLeft -= L; };
      row.addEventListener('scroll', () => { if (!animating && !drag) normalize(); }, { passive: true });
      const goTo = (left) => {
        animating = true;
        row.scrollTo({ left, behavior: 'smooth' });
        const t0 = Date.now();
        const settle = () => { if (Math.abs(row.scrollLeft - left) < 2 || Date.now() - t0 > 1200) { animating = false; normalize(); } else requestAnimationFrame(settle); };
        requestAnimationFrame(settle);
      };
      const SPEED = 90;
      let pos = row.scrollLeft, last = 0;
      const tick = (now) => {
        if (last) {
          const dt = Math.min(50, now - last) / 1000;
          const active = inView && !hovering && !drag && !animating && Date.now() > pausedUntil && !reduced() && !document.hidden;
          if (active) {
            if (Math.abs(row.scrollLeft - pos) > 2) pos = row.scrollLeft;
            pos += SPEED * dt;
            const L = loopWidth(); if (pos >= L) pos -= L;
            row.scrollLeft = pos;
          } else { pos = row.scrollLeft; }
        }
        last = now; requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      const pause = () => (pausedUntil = Date.now() + 2500);
      row.addEventListener('pointerdown', pause);
      row.addEventListener('wheel', pause, { passive: true });
      row.addEventListener('touchstart', pause, { passive: true });
      row.addEventListener('mouseenter', () => (hovering = true));
      row.addEventListener('mouseleave', () => (hovering = false));
      row.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        row.classList.add('is-dragging');
        drag = { x: e.clientX, left: row.scrollLeft, moved: false };
      });
      row.addEventListener('pointermove', (e) => {
        if (!drag) return;
        const dx = e.clientX - drag.x;
        if (!drag.moved && Math.abs(dx) > 3) { drag.moved = true; const L = loopWidth(); if (drag.left < L) drag.left += L; try { row.setPointerCapture(e.pointerId); } catch (_) {} }
        if (drag.moved) row.scrollLeft = drag.left - dx;
      });
      const endDrag = (e) => {
        if (!drag) return;
        const moved = drag.moved; drag = null;
        row.classList.remove('is-dragging'); try { row.releasePointerCapture(e.pointerId); } catch (_) {}
        normalize();
        if (moved) { const g = gutter(); const nearest = [...row.children].reduce((best, c) => Math.abs(c.offsetLeft - g - row.scrollLeft) < Math.abs(best.offsetLeft - g - row.scrollLeft) ? c : best); goTo(nearest.offsetLeft - g); pause(); }
      };
      row.addEventListener('dragstart', (e) => e.preventDefault());
      row.addEventListener('pointerup', endDrag);
      row.addEventListener('pointercancel', endDrag);
      row.addEventListener('click', (e) => { if (drag?.moved) e.preventDefault(); }, true);
      wrap.querySelectorAll('[data-cvl-nudge]').forEach((btn) => btn.addEventListener('click', () => {
        const dir = Number(btn.dataset.cvlNudge) || 1;
        const w = originals[0].offsetWidth + gap();
        let target = row.scrollLeft + dir * w;
        if (target < 0) { row.scrollLeft += loopWidth(); target = row.scrollLeft + dir * w; }
        goTo(target); pause();
      }));
    });
  };

  /* ---------- 车系 chip ---------- */
  const prepareSeries = (page) => {
    page.querySelectorAll('[data-cvl-series]').forEach((box) => {
      const out = box.querySelector('[data-cvl-series-out]');
      const chips = box.querySelectorAll('[data-cvl-series-chip]');
      chips.forEach((chip) => chip.addEventListener('click', () => {
        const on = chip.getAttribute('aria-pressed') === 'true';
        chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
        if (on) { out.textContent = ''; return; }
        chip.setAttribute('aria-pressed', 'true');
        out.textContent = '';
        const strong = document.createElement('strong'); strong.textContent = chip.dataset.models || '';
        out.append(strong, ' · ' + (chip.dataset.note || ''));
      }));
    });
  };

  /* ---------- 兼容车型筛选 ---------- */
  const prepareFit = (page) => {
    page.querySelectorAll('[data-cvl-fit]').forEach((box) => {
      const input = box.querySelector('[data-cvl-fit-input]'); const chips = [...box.querySelectorAll('.cvl-fitchip')]; const groups = [...box.querySelectorAll('[data-cvl-fit-group]')]; const empty = box.querySelector('[data-cvl-fit-empty]');
      const fams = [...box.querySelectorAll('[data-cvl-fit-family]')]; let family = '';
      const apply = (q) => {
        q = (q || '').trim().toLowerCase();
        let hits = 0;
        chips.forEach((c) => { const inFam = !family || c.closest('[data-cvl-fit-group]')?.dataset.cvlFitGroup === family; const on = inFam && (!q || c.dataset.text.includes(q)); c.hidden = !on; c.classList.toggle('is-hit', !!q && on); if (on) hits++; });
        groups.forEach((g) => { g.hidden = ![...g.querySelectorAll('.cvl-fitchip')].some((c) => !c.hidden); });
        if (empty) empty.hidden = hits > 0;
      };
      fams.forEach((b) => b.addEventListener('click', () => { family = family === b.dataset.cvlFitFamily ? '' : b.dataset.cvlFitFamily; fams.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.cvlFitFamily === family))); apply(input?.value); }));
      input?.addEventListener('input', () => apply(input.value));
      page.querySelectorAll('[data-cvl-model]').forEach((m) => m.addEventListener('input', () => { if (input && !input.value) apply(m.value); }));
    });
  };

  /* ---------- 车型表单：多份表单互相同步 ---------- */
  /* ---------- 车型记忆 / 预填：URL 参数 (?model=M3&year=2022) 优先，其次上次填写的（localStorage） ---------- */
  const VEH_KEY = 'cvl-vehicle';
  const YEAR_MIN = 1990;
  // 检测记录：每次兼容检测 POST 到 <接口>/save 存表，下单时再更新状态
  const SID_KEY = 'cvl_sid';
  // Worker 端共享密钥校验（X-App-Key）：车型检测接口 + /save 这两处调用都要带上，跟 Cloudflare 环境变量 APP_SHARED_KEY 保持一致
  const APP_KEY = 'a7f3e8f070bb8b2fcf62cffbd27a60476811019218d1b979';
  // 「加购」而非「下单」——Buy now 目前只是加入购物车，不代表支付已完成
  const FIT_STATUS = { checkedOk: '兼容未加购', checkedBad: '不兼容未加购', orderedOk: '兼容已加购', orderedBad: '不兼容已加购' };
  const sessionId = () => { try { let sid = sessionStorage.getItem(SID_KEY); if (!sid) { sid = 'S' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).slice(2, 6).toUpperCase(); sessionStorage.setItem(SID_KEY, sid); } return sid; } catch (e) { return ''; } };
  const recordFit = (endpoint, fit, orderStatus, customerConfirm = '') => {
    if (!endpoint || !fit || !fit.testId) return;
    const d = fit.data || {};
    fetch(endpoint + '/save', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-App-Key': APP_KEY }, body: JSON.stringify({
      testId: fit.testId, sessionId: sessionId(), model: fit.model, year: fit.year,
      badgeSize: d.size || '', camera: d.camera === 'no' ? 'No' : d.camera === 'yes' ? 'Yes' : d.camera === 'possible' ? 'Possible' : 'Unknown', specialMount: d.special_mount === 'no' ? 'No' : d.special_mount === 'yes' ? 'Yes' : 'Unknown',
      verdict: fit.verdict, source: document.querySelector('.cvl--founding') ? 'Founding page' : 'Product page', aiNote: d.internal_note || d.note || '', customerConfirm, orderStatus, orderId: '' }) }).catch(() => {});
  };
  const readVehicle = () => {
    try {
      const q = new URLSearchParams(location.search);
      const fromUrl = { model: (q.get('model') || '').trim(), year: (q.get('year') || '').trim() };
      if (fromUrl.model || fromUrl.year) return fromUrl;
      return JSON.parse(localStorage.getItem(VEH_KEY) || 'null') || {};
    } catch (e) { return {}; }
  };
  const saveVehicle = (model, year) => { try { localStorage.setItem(VEH_KEY, JSON.stringify({ model, year })); } catch (e) {} };
  const utmNote = () => {
    try { const q = new URLSearchParams(location.search); const parts = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].map((k) => q.get(k)).filter(Boolean); return parts.length ? ' | utm: ' + parts.join('/') : ''; } catch (e) { return ''; }
  };
  const prefillForm = (form) => {
    const v = readVehicle(); const m = form.querySelector('[data-cvl-model]'), y = form.querySelector('[data-cvl-year]');
    if (m && !m.value && v.model) m.value = v.model; if (y && !y.value && v.year) y.value = v.year;
  };
  const prepareVehicleForms = (page) => {
    const forms = [...page.querySelectorAll('[data-cvl-vehicle-form]')];
    const sync = (source, selector) => forms.forEach((f) => { const t = f.querySelector(selector); if (t && t !== source) t.value = source.value; });
    forms.forEach((form) => {
      prefillForm(form);
      form.querySelector('[data-cvl-model]')?.addEventListener('input', (e) => sync(e.currentTarget, '[data-cvl-model]'));
      form.querySelector('[data-cvl-year]')?.addEventListener('input', (e) => sync(e.currentTarget, '[data-cvl-year]'));
    });
  };

  /* ---------- Fitment 弹窗（首屏内联表单模式用）---------- */
  const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };

  /* ---------- 检测中的加载状态样式：绿色渐进进度条 + 按钮扫光，只注入一次 ---------- */
  const injectFitLoadingStyles = () => {
    if (document.getElementById('cvl-fit-loading-style')) return;
    const style = document.createElement('style');
    style.id = 'cvl-fit-loading-style';
    style.textContent = `
      .cvl-fit-loading{padding:4px 0 8px}
      .cvl-fit-loading__sub{opacity:.75;transition:opacity .25s ease}
      .cvl-fit-loading__bar{position:relative;height:4px;border-radius:4px;overflow:hidden;background:rgba(0,217,255,.14);margin-top:16px}
      .cvl-fit-loading__bar i{position:absolute;top:0;left:-45%;width:45%;height:100%;border-radius:4px;background:linear-gradient(90deg,rgba(0,217,255,0),rgba(0,217,255,.95),rgba(0,217,255,0));animation:cvlFitLoadSweep 1.15s ease-in-out infinite}
      @keyframes cvlFitLoadSweep{0%{left:-45%}100%{left:100%}}
      [data-cvl-add].is-checking{position:relative;overflow:hidden}
      [data-cvl-add].is-checking::after{content:'';position:absolute;inset:0;background:linear-gradient(100deg,transparent 35%,rgba(255,255,255,.35) 50%,transparent 65%);transform:translateX(-100%);animation:cvlBtnSheen 1.15s ease-in-out infinite}
      @keyframes cvlBtnSheen{100%{transform:translateX(100%)}}
      .cvl-modal [data-cvl-model]:not(.is-invalid),.cvl-modal [data-cvl-year]:not(.is-invalid){border:1px solid #00D9FF !important}
      .cvl-modal [data-cvl-model]:not(.is-invalid):focus,.cvl-modal [data-cvl-year]:not(.is-invalid):focus{outline:none !important;box-shadow:0 0 0 3px rgba(0,217,255,.25) !important}
      .cvl-fit-options{display:flex;flex-direction:column;gap:8px;margin:14px 0 6px}
      .cvl-fit-option{appearance:none;-webkit-appearance:none;width:100%;padding:12px 14px;border:1px solid #00D9FF;border-radius:10px;background:rgba(0,217,255,.08);color:#00D9FF;font:inherit;font-weight:600;text-align:left;cursor:pointer;transition:background .15s ease}
      .cvl-fit-option:hover,.cvl-fit-option:focus-visible{background:rgba(0,217,255,.18);outline:none}
      .cvl-fit-installcheck{margin-top:12px;padding:12px 14px;border:1px solid rgba(0,217,255,.35);border-radius:10px;font-size:.92em;opacity:.9}
    `;
    document.head.appendChild(style);
  };
  /* 生成"检测中"这一屏的内容：标题 + 说明文字（可切换）+ 绿色进度条 */
  const fitLoadingView = (v) => {
    injectFitLoadingStyles();
    const box = el('div', 'cvl-fit-loading');
    box.appendChild(el('div', 'cvl-modal__title', 'Checking compatibility…'));
    const sub = el('div', 'cvl-modal__body cvl-fit-loading__sub', `Matching BMW ${v.model} ${v.year} against our fitment database…`);
    box.appendChild(sub);
    const bar = el('div', 'cvl-fit-loading__bar'); bar.appendChild(el('i'));
    box.appendChild(bar);
    return { box, sub };
  };
  const showFitmentModal = (type) => new Promise((resolve) => {
    const overlay = el('div', 'cvl-modal-overlay');
    const modal = el('div', 'cvl-modal');
    overlay.appendChild(modal);
    const close = (value) => { overlay.classList.remove('is-visible'); setTimeout(() => { overlay.remove(); resolve(value); }, 200); };
    const closeBtn = el('button', 'cvl-modal__close', '×'); closeBtn.type = 'button'; closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.addEventListener('click', () => close(false));
    modal.appendChild(closeBtn);
    if (type === 'check') {
      modal.appendChild(el('div', 'cvl-modal__title', 'Please confirm before ordering'));
      modal.appendChild(el('div', 'cvl-modal__body', 'Some vehicles with this model year may have a camera or special mount inside the rear badge. Please confirm yours before proceeding.'));
      const list = el('div', 'cvl-modal__list');
      const boxes = ['My rear badge does not have a built-in camera', 'My rear badge does not have a flip-up mechanism', 'My badge is a standard adhesive roundel (74 mm or 82 mm)'].map((t) => {
        const label = el('label', 'cvl-modal__check'); const cb = el('input'); cb.type = 'checkbox'; label.append(cb, el('span', null, t)); list.appendChild(label); return cb;
      });
      modal.appendChild(list);
      const btns = el('div', 'cvl-modal__btns');
      const confirm = el('button', 'cvl-modal__primary', 'Confirm & buy now'); confirm.type = 'button'; confirm.disabled = true;
      boxes.forEach((cb) => cb.addEventListener('change', () => (confirm.disabled = !boxes.every((b) => b.checked))));
      confirm.addEventListener('click', () => close(true));
      const support = el('a', 'cvl-modal__secondary', 'Not sure — contact support'); support.href = '/pages/contact';
      btns.append(confirm, support); modal.appendChild(btns);
    } else if (type === 'camera') {
      modal.appendChild(el('div', 'cvl-modal__title', 'This vehicle may not be compatible'));
      modal.appendChild(el('div', 'cvl-modal__body', 'Your rear badge appears to contain an integrated camera. Removing it may permanently disable your parking camera system. We strongly advise against proceeding.'));
      const btns = el('div', 'cvl-modal__btns');
      const support = el('a', 'cvl-modal__primary', 'Contact support'); support.href = '/pages/contact';
      const anyway = el('button', 'cvl-modal__secondary', 'Order anyway — I understand removing the badge may disable my camera'); anyway.type = 'button'; anyway.addEventListener('click', () => close(true));
      btns.append(support, anyway); modal.appendChild(btns);
    } else if (type === 'invalid') {
      modal.appendChild(el('div', 'cvl-modal__title', 'Vehicle not found'));
      modal.appendChild(el('div', 'cvl-modal__body', 'Sorry, we couldn\'t find your vehicle. Please check your BMW model and year are correct, or contact us for help.'));
      const btns = el('div', 'cvl-modal__btns');
      const wa = el('a', 'cvl-modal__primary', 'Contact us on WhatsApp'); wa.href = 'https://wa.me/12133012742'; wa.target = '_blank';
      const emailUs = el('a', 'cvl-modal__secondary', 'Email us'); emailUs.href = '/pages/contact';
      btns.append(wa, emailUs); modal.appendChild(btns);
    } else {
      modal.appendChild(el('div', 'cvl-modal__title', 'This vehicle may not be compatible'));
      modal.appendChild(el('div', 'cvl-modal__body', 'Your rear badge appears to have a separate mounting base. The CARLUEX Digital Emblem for BMW requires a cable entry hole behind the badge. Vehicles with a fixed base mount typically do not have this hole, which prevents installation.\n\nIf you\'re willing to drill two small holes, installation may still be possible — contact us first.'));
      const btns = el('div', 'cvl-modal__btns');
      const support = el('a', 'cvl-modal__primary', 'Contact support'); support.href = '/pages/contact';
      const anyway = el('button', 'cvl-modal__secondary', 'Order anyway — I understand and accept the risk'); anyway.type = 'button'; anyway.addEventListener('click', () => close(true));
      btns.append(support, anyway); modal.appendChild(btns);
    }
    document.body.appendChild(overlay);
    requestAnimationFrame(() => overlay.classList.add('is-visible'));
  });

  /* ---------- 加购：校验 → fitment → cart/add.js（带属性）→ cart/update.js（备注）→ /checkout ---------- */
  const showFieldError = (input, msg) => {
    if (!input) return;
    const label = input.closest('label') || input.parentElement;
    let err = label.querySelector('.cvl-field__error');
    if (!err) { err = el('span', 'cvl-field__error'); label.appendChild(err); }
    err.textContent = msg; input.classList.add('is-invalid'); input.setAttribute('aria-invalid', 'true'); input.focus();
    const clear = () => { if (input.checkValidity()) { err.remove(); input.classList.remove('is-invalid'); input.removeAttribute('aria-invalid'); input.removeEventListener('input', clear); } };
    input.addEventListener('input', clear);
  };
  const removeUpstreamPayPal = (page) => {
    const kill = (n) => { if (n && n.nodeType === 1 && n.id === 'paypal-upstream-messaging-product' && page.contains(n) && !n.closest('.cvl-terms, shopify-payment-terms') && page.querySelector('shopify-payment-terms')) n.remove(); };
    const restyle = (n) => { if (n && n.nodeType === 1 && n.id === 'paypal-upstream-messaging-product' && page.contains(n)) { n.setAttribute('data-pp-style-text-color', 'white'); n.setAttribute('data-pp-style-text-size', '12'); mirror(n); } };
    let mirrored = false;
    const mirror = (src) => {
      if (mirrored) return; const box = page.querySelector('.cvl-preorder__box'); if (!box) return; mirrored = true;
      const m = document.createElement('div'); m.className = 'cvl-pp-msg';
      for (const a of src.attributes) if (a.name.startsWith('data-pp-')) m.setAttribute(a.name, a.value);
      m.setAttribute('data-pp-style-text-align', 'center');
      const anchor = box.querySelector('.cvl-terms') || box.querySelector('.cvl-preorder__price'); anchor.after(m);
      const tryRender = (n) => { try { if (window.paypal && window.paypal.Messages && !m.querySelector('iframe')) window.paypal.Messages({ amount: m.getAttribute('data-pp-amount') || undefined, placement: 'product', style: { layout: 'text', logo: { type: 'inline' }, text: { color: 'white', size: 12, align: 'center' } } }).render(m); } catch (e) {} if (n < 6 && !m.querySelector('iframe')) setTimeout(() => tryRender(n + 1), 800); };
      setTimeout(() => tryRender(0), 800);
    };
    const handle = (n) => { kill(n); if (n && n.isConnected) restyle(n); };
    page.querySelectorAll('#paypal-upstream-messaging-product').forEach(handle);
    new MutationObserver((muts) => muts.forEach((m) => m.addedNodes.forEach((n) => { handle(n); n.querySelectorAll?.('#paypal-upstream-messaging-product').forEach(handle); }))).observe(page, { childList: true, subtree: true });
  };
  /* ---------- 车型弹窗（form_mode = modal） ---------- */
  const openVehicleModal = (tpl, opts = {}) => {
    const overlay = el('div', 'cvl-modal-overlay'); const modal = el('div', 'cvl-modal cvl-modal--vehicle'); overlay.appendChild(modal);
    const close = () => { overlay.classList.remove('is-visible'); setTimeout(() => overlay.remove(), 200); };
    const closeBtn = el('button', 'cvl-modal__close', '×'); closeBtn.type = 'button'; closeBtn.setAttribute('aria-label', 'Close'); closeBtn.addEventListener('click', close);
    modal.appendChild(closeBtn);
    const body = el('div', 'cvl-modal__stage'); modal.appendChild(body);
    body.appendChild(el('div', 'cvl-modal__title', opts.title || tpl.dataset.title || 'Which BMW is it for?'));
    const text = opts.body ?? tpl.dataset.body; if (text) body.appendChild(el('div', 'cvl-modal__body', text));
    const form = tpl.content.firstElementChild.cloneNode(true); body.appendChild(form); prefillForm(form);
    const btns = el('div', 'cvl-modal__btns'); const go = el('button', 'cvl-modal__primary', opts.cta || tpl.dataset.cta || 'Continue to checkout'); go.type = 'button'; btns.appendChild(go); body.appendChild(btns);
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });
    document.body.appendChild(overlay); requestAnimationFrame(() => { overlay.classList.add('is-visible'); (form.querySelector('[data-cvl-model]:placeholder-shown') || form.querySelector('[data-cvl-year]:placeholder-shown'))?.focus(); });
    const showResult = (node) => { body.replaceChildren(node); };
    return { form, button: go, close, showResult };
  };

  const prepareCart = (page) => {
    let adding = false;
    const sizePicker = page.querySelector('[data-cvl-size-picker]');
    let chosenVariant = sizePicker?.querySelector('select').value || '';
    const syncSize = (id) => {
      chosenVariant = id;
      if (id) page.dataset.variantId = id;
      page.querySelectorAll('[data-cvl-size]').forEach((select) => { select.value = id; select.removeAttribute('aria-invalid'); });
      page.querySelectorAll('input[name="id"]').forEach((input) => { if (id) input.value = id; });
      const url = new URL(location.href);
      if (id) url.searchParams.set('variant', id); else url.searchParams.delete('variant');
      history.replaceState(history.state, '', url);
    };
    page.addEventListener('change', (event) => {
      if (event.target.matches('[data-cvl-size]')) syncSize(event.target.value);
    });
    let pendingSizePurchase = null;
    let sizeDialog = null;
    const openSizeDialog = (button, vehicle, mode) => {
      if (!sizeDialog) {
        sizeDialog = document.createElement('dialog');
        sizeDialog.className = 'cvl-sku-dialog';
        const title = el('h2', 'cvl-sku-title', sizePicker.dataset.title);
        title.id = `cvl-sku-title-${page.dataset.variantId}`;
        sizeDialog.setAttribute('aria-labelledby', title.id);
        const description = el('p', 'cvl-sku-description', sizePicker.dataset.description);
        description.id = `${title.id}-description`;
        sizeDialog.setAttribute('aria-describedby', description.id);
        const close = el('button', 'cvl-sku-close', '×'); close.type = 'button';
        close.setAttribute('aria-label', sizePicker.dataset.close);
        close.addEventListener('click', () => sizeDialog.close());
        const options = el('div', 'cvl-sku-options');
        options.setAttribute('role', 'group'); options.setAttribute('aria-label', sizePicker.querySelector('span').textContent);
        const proceed = el('button', 'cvl-sku-proceed'); proceed.type = 'button';
        [...sizePicker.querySelector('select').options].filter((option) => option.value).forEach((option) => {
          const choice = el('button', 'cvl-sku-option', option.textContent); choice.type = 'button';
          choice.dataset.variant = option.value; choice.disabled = option.disabled;
          choice.setAttribute('aria-pressed', 'false');
          choice.addEventListener('click', () => {
            syncSize(option.value);
            options.querySelectorAll('button').forEach((node) => node.setAttribute('aria-pressed', String(node === choice)));
            proceed.disabled = false;
          }); options.appendChild(choice);
        });
        proceed.addEventListener('click', () => {
          if (!chosenVariant || !pendingSizePurchase) return;
          const pending = pendingSizePurchase;
          sizeDialog.close();
          runPurchase(pending.button, pending.vehicle, pending.mode, true);
        });
        sizeDialog.addEventListener('close', () => { pendingSizePurchase = null; });
        sizeDialog.addEventListener('click', (event) => { if (event.target === sizeDialog) { const r = sizeDialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) sizeDialog.close(); } });
        sizeDialog.append(close, title, description, options, proceed); page.appendChild(sizeDialog);
      }
      pendingSizePurchase = { button, vehicle, mode };
      sizeDialog.querySelector('.cvl-sku-proceed').textContent = button.textContent.trim();
      sizeDialog.querySelector('.cvl-sku-proceed').disabled = !chosenVariant;
      sizeDialog.querySelectorAll('[data-variant]').forEach((node) => node.setAttribute('aria-pressed', String(node.dataset.variant === chosenVariant)));
      sizeDialog.showModal();
    };
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const modalTpl = page.querySelector('template[data-cvl-vehicle-modal]');
    const pageDiscountCode = (page.dataset.discountCode || '').trim();
    const orderTag = (page.dataset.orderTag || '').trim();
    const endpoint = page.dataset.fitmentEndpoint;
    const fitline = page.querySelector('[data-cvl-fitline]');

    /* --- 兼容检测：独立于购买。结果按 (model, year) 记一份，同一辆车不重复问接口 --- */
    let lastFit = null;
    const fetchFitment = async (model, year) => {
      if (lastFit && lastFit.model === model && lastFit.year === year) return lastFit;
      let verdict = 'ship', data = {}, note = '';
      if (!endpoint) { note = `BMW ${model} ${year} | manual verify needed`; verdict = 'check'; }
      else {
        try {
          const res = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-App-Key': APP_KEY }, body: JSON.stringify({ model, year }) });
          data = await res.json();
          verdict = data.verdict || 'ship';
          const cam = data.camera === 'no' ? 'No' : data.camera === 'yes' ? 'Yes' : data.camera === 'possible' ? 'Possible' : 'Unknown';
          const mnt = data.special_mount === 'no' ? 'No' : data.special_mount === 'yes' ? 'Yes' : 'Unknown';
          // 订单备注用 Worker 给内部的简短版本（internal_note）；note 是给客户看的长说明，只在弹窗里显示
          note = `BMW ${model} ${year} | Badge: ${data.size} | Camera: ${cam} | Mount: ${mnt} | ${verdict} | ${data.internal_note || data.note}`;
          if (data.order && typeof data.order.note === 'string') note = data.order.note; // 新版 Worker 直接给好订单备注
        } catch (e) { note = `BMW ${model} ${year} | AI check failed - manual verify needed`; verdict = 'check'; }
      }
      lastFit = { model, year, verdict, data, note, confirmed: false, testId: 'T' + Date.now().toString(36).toUpperCase() };
      recordFit(endpoint, lastFit, verdict === 'ship' ? FIT_STATUS.checkedOk : FIT_STATUS.checkedBad);
      return lastFit;
    };
    const validVehicle = (form) => {
      const modelInput = form.querySelector('[data-cvl-model]'), yearInput = form.querySelector('[data-cvl-year]');
      const model = modelInput?.value.trim() || '', year = yearInput?.value.trim() || '';
      if (!model || !modelInput.checkValidity()) { showFieldError(modelInput, 'Please enter your BMW model, e.g. X5 or M4'); return null; }
      if (!year || !yearInput.checkValidity()) { showFieldError(yearInput, 'Please enter a 4-digit model year, e.g. 2024'); return null; }
      if (Number(year) < YEAR_MIN || Number(year) > new Date().getFullYear() + 1) { showFieldError(yearInput, `Model year should be between ${YEAR_MIN} and ${new Date().getFullYear() + 1}`); return null; }
      return { model, year };
    };
    // Worker 给的颜色（titleTone / fitline.tone）：ok = 品牌青色，warn = 提醒黄色，white = 白色，
    // 也可以直接写颜色值（如 '#FF5A5A'）；neutral 或不写 = 用主题默认颜色
    const uiToneColor = (t) => t === 'ok' ? '#00D9FF' : t === 'warn' ? '#FFC24B' : t === 'white' ? '#FFFFFF' : (typeof t === 'string' && /^#[0-9a-f]{3,8}$/i.test(t)) ? t : '';
    const renderFitline = (fit) => {
      if (!fitline) return;
      const out = fitline.querySelector('[data-cvl-fit-result]'), btn = fitline.querySelector('[data-cvl-check-fit]');
      if (!fit) { out.hidden = true; btn.textContent = btn.dataset.label; out.style.removeProperty('color'); out.style.removeProperty('border-color'); return; }
      // 新版 Worker 给了 ui.fitline → 直接用它的文字和颜色
      const uiLine = fit.data && fit.data.ui && fit.data.ui.fitline;
      if (uiLine && uiLine.text) {
        out.textContent = uiLine.text; out.dataset.verdict = fit.verdict; out.hidden = false; btn.textContent = 'Change';
        const lc = uiToneColor(uiLine.tone);
        if (lc) { out.style.setProperty('color', lc, 'important'); out.style.setProperty('border-color', lc, 'important'); }
        else { out.style.removeProperty('color'); out.style.removeProperty('border-color'); }
        return;
      }
      const unverified = fit.verdict === 'ship' && fit.data && fit.data.install_check;
      const label = unverified ? `BMW ${fit.model} ${fit.year} · size matches · check before purchasing` : fit.verdict === 'ship' ? `Confirmed fit — BMW ${fit.model} ${fit.year}` : fit.verdict === 'invalid' ? `BMW ${fit.model} ${fit.year} · not found` : fit.verdict === 'check' ? `BMW ${fit.model} ${fit.year} · needs a closer look` : `BMW ${fit.model} ${fit.year} · may not be compatible`;
      out.textContent = label; out.dataset.verdict = fit.verdict; out.hidden = false; btn.textContent = 'Change';
      // 统一颜色：ship 状态用品牌青蓝色覆盖外部样式表里默认的绿色，跟弹窗里的结果配色保持一致
      if (fit.verdict === 'ship' && !unverified) { out.style.setProperty('color', '#00D9FF', 'important'); out.style.setProperty('border-color', '#00D9FF', 'important'); }
      else { out.style.removeProperty('color'); out.style.removeProperty('border-color'); }
    };
    const openFitCheck = () => {
      if (!modalTpl) return;
      const m = openVehicleModal(modalTpl, { title: modalTpl.dataset.checkTitle, body: modalTpl.dataset.checkBody, cta: modalTpl.dataset.checkCta });
      // 查询 + 显示结果。表单提交和"车身选项按钮"都走这里
      let checking = false;
      const check = async (v) => {
        if (checking) return;
        checking = true;
        m.button.disabled = true; m.button.textContent = 'Checking…';
        const loading = fitLoadingView(v);
        m.showResult(loading.box);
        // 现在只查表，通常 1 秒内出结果；超过 4 秒一般是客户网速慢，换一句中性的耐心提示
        const upgradeTimer = setTimeout(() => {
          loading.sub.style.opacity = '0';
          setTimeout(() => { loading.sub.textContent = `Still checking — this can take a few seconds on slow connections…`; loading.sub.style.opacity = '.75'; }, 250);
        }, 4000);
        const fit = await fetchFitment(v.model, v.year);
        clearTimeout(upgradeTimer);
        saveVehicle(v.model, v.year); renderFitline(fit);
        m.showResult(fitResultView(fit, m));
        checking = false;
      };
      // 车身选项按钮：把选好的车型（如 "335xi Sedan"）写回页面上所有车型输入框，再直接重新查询
      m.recheck = (model, year) => {
        page.querySelectorAll('[data-cvl-model]').forEach((i) => { i.value = model; });
        const mi = m.form.querySelector('[data-cvl-model]'); if (mi) mi.value = model;
        return check({ model, year });
      };
      const run = () => { const v = validVehicle(m.form); if (v) check(v); };
      m.button.addEventListener('click', run);
      m.form.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    };
    // 结论页：ship / do_not_ship(camera|mount) / invalid / check 四种各自独立展示与操作
    const fitResultView = (fit, m) => {
      // 显示 Worker 返回的 note：按 \n 换行显示；多行内容（比如自查清单）改成左对齐，读起来更清楚
      const noteBody = (text) => {
        const n = el('div', 'cvl-modal__body', text);
        n.style.whiteSpace = 'pre-line';
        if (text.includes('\n')) n.style.textAlign = 'left';
        return n;
      };
      const box = el('div', 'cvl-fitresult'); box.dataset.verdict = fit.verdict;
      const d = fit.data || {};
      // ── 新版 Worker 返回 ui：弹窗内容全部按 Worker 的描述来画（文案/按钮/勾选清单都在 Worker 里改）──
      // 旧版 Worker 没有 ui → 走下面原来的写死显示方式
      if (d.ui && Array.isArray(d.ui.blocks)) {
        const ui = d.ui;
        const title = el('div', 'cvl-modal__title', ui.title || '');
        const tc = uiToneColor(ui.titleTone); if (tc) title.style.setProperty('color', tc, 'important');
        box.appendChild(title);
        ui.blocks.forEach((b) => {
          if (!b) return;
          if (b.type === 'text') box.appendChild(noteBody(String(b.text || '')));
          else if (b.type === 'box') { const n = noteBody(String(b.text || '')); n.classList.add('cvl-fit-installcheck'); box.appendChild(n); }
          else if (b.type === 'checklist' && Array.isArray(b.items)) {
            // 勾选清单：不拦购买；勾选状态记在 fit.selfCheck，下单时按 Worker 给的写法写进订单备注和 Sheets
            const ic = el('div', 'cvl-fit-installcheck');
            if (b.intro) ic.appendChild(el('div', 'cvl-modal__body', b.intro));
            const list = el('div', 'cvl-modal__list');
            if (!fit.selfCheck || fit.selfCheck.length !== b.items.length) fit.selfCheck = b.items.map((it) => ({ item: it.label, short: it.short || it.label, checked: false }));
            b.items.forEach((it, i) => {
              const label = el('label', 'cvl-modal__check'); const cb = el('input'); cb.type = 'checkbox'; cb.checked = fit.selfCheck[i].checked;
              cb.addEventListener('change', () => { fit.selfCheck[i].checked = cb.checked; });
              label.append(cb, el('span', null, it.label)); list.appendChild(label);
            });
            ic.appendChild(list);
            if (b.outro) ic.appendChild(el('div', 'cvl-modal__body', b.outro));
            box.appendChild(ic);
          } else if (b.type === 'options' && Array.isArray(b.items) && m && m.recheck) {
            const list = el('div', 'cvl-fit-options');
            b.items.filter((o) => o && o.label && o.query).forEach((o) => {
              const ob = el('button', 'cvl-fit-option', o.label); ob.type = 'button';
              ob.addEventListener('click', () => m.recheck(o.query, fit.year));
              list.appendChild(ob);
            });
            box.appendChild(list);
          }
        });
        const ubtns = el('div', 'cvl-modal__btns');
        const pageBuyLabel = page.querySelector('[data-cvl-add]:not([data-cvl-add-only]) .cvl-btn__face')?.textContent.trim() || 'Buy now';
        (Array.isArray(ui.buttons) ? ui.buttons : []).forEach((bt) => {
          if (!bt) return;
          const cls = bt.style === 'primary' ? 'cvl-modal__primary' : 'cvl-modal__secondary';
          let n;
          if (bt.action === 'checkout') {
            n = el('button', cls, bt.label || pageBuyLabel); n.type = 'button';
            n.addEventListener('click', () => { fit.confirmed = true; runPurchase(n, fit, 'checkout'); });
          } else if (bt.action === 'cart') {
            n = el('button', cls, bt.label || 'Add to cart'); n.type = 'button';
            n.addEventListener('click', () => { fit.confirmed = true; runPurchase(n, fit, 'cart').then((ok) => { if (ok) m.close(); }); });
          } else if (bt.action === 'link' && bt.href) {
            n = el('a', cls, bt.label || bt.href); n.href = bt.href;
            if (/^https?:/i.test(bt.href)) { n.target = '_blank'; n.rel = 'noopener'; }
          } else return;
          if (bt.style === 'accent') { n.style.borderColor = '#00D9FF'; n.style.color = '#00D9FF'; }
          ubtns.appendChild(n);
        });
        box.appendChild(ubtns);
        return box;
      }
      const facts = [d.size && `Badge size: ${d.size}`, d.camera && `Camera in badge: ${d.camera === 'no' ? 'no' : d.camera === 'yes' ? 'yes' : 'possible'}`, d.special_mount && `Special mount: ${d.special_mount === 'no' ? 'no' : d.special_mount === 'yes' ? 'yes' : 'unknown'}`].filter(Boolean);
      const btns = el('div', 'cvl-modal__btns');
      if (fit.verdict === 'ship') {
        // 有安装前自查提示（摄像头/开箱按钮/底座没确认）时，只说尺寸对得上，不说"Confirmed fit"，避免跟自查提示矛盾
        const title = el('div', 'cvl-modal__title', d.install_check ? 'Size matches — please check before purchasing' : 'Confirmed fit. Ready to ship.');
        if (!d.install_check) title.style.color = '#00D9FF';
        box.appendChild(title);
        box.appendChild(el('div', 'cvl-modal__body', (facts.length ? facts.join(' · ') + '.' : '')));
        // 摄像头/开箱按钮/底座还没确认的车型（联网来源）：Worker 附上 install_check，显示安装前自查提示
        // 做成勾选清单：以 "•" 开头的行变成复选框，其余行（开头/结尾说明）显示为文字。
        // 不拦购买（2026-09-24 规则）；勾选状态记在 fit.selfCheck，下单时写进订单备注和 Sheets，客服据此跟进
        if (d.install_check) {
          const lines = String(d.install_check).split('\n');
          const ic = el('div', 'cvl-fit-installcheck');
          const head = lines.filter((l) => !/^\s*[•\-]/.test(l));
          if (head[0]) ic.appendChild(el('div', 'cvl-modal__body', head[0]));
          const list = el('div', 'cvl-modal__list');
          const items = lines.filter((l) => /^\s*[•\-]/.test(l)).map((l) => l.replace(/^\s*[•\-]\s*/, ''));
          if (!fit.selfCheck || fit.selfCheck.length !== items.length) fit.selfCheck = items.map((t) => ({ item: t, checked: false }));
          items.forEach((t, i) => {
            const label = el('label', 'cvl-modal__check'); const cb = el('input'); cb.type = 'checkbox'; cb.checked = fit.selfCheck[i].checked;
            cb.addEventListener('change', () => { fit.selfCheck[i].checked = cb.checked; });
            label.append(cb, el('span', null, t)); list.appendChild(label);
          });
          ic.appendChild(list);
          if (head.length > 1) ic.appendChild(el('div', 'cvl-modal__body', head.slice(1).join(' ')));
          box.appendChild(ic);
        }
        const buy = el('button', 'cvl-modal__primary', page.querySelector('[data-cvl-add]:not([data-cvl-add-only]) .cvl-btn__face')?.textContent.trim() || 'Buy now'); buy.type = 'button';
        buy.addEventListener('click', () => { fit.confirmed = true; runPurchase(buy, fit, 'checkout'); });
        const add = el('button', 'cvl-modal__secondary', 'Add to cart'); add.type = 'button';
        add.addEventListener('click', () => { fit.confirmed = true; runPurchase(add, fit, 'cart').then((ok) => { if (ok) m.close(); }); });
        btns.append(buy, add);
        // 有安装前自查提示的（摄像头/开箱按钮/底座没确认）：同时给出联系客服的入口，客户拿不准可以先问
        if (d.install_check) {
          const wa = el('a', 'cvl-modal__secondary', 'Not sure — contact us on WhatsApp'); wa.href = 'https://wa.me/12133012742'; wa.target = '_blank'; wa.style.borderColor = '#00D9FF'; wa.style.color = '#00D9FF';
          const emailUs = el('a', 'cvl-modal__secondary', 'Email us'); emailUs.href = '/pages/contact';
          btns.append(wa, emailUs);
        }
      } else if (fit.verdict === 'do_not_ship') {
        // 正文直接用 Worker 返回的 note（后端 REASON_TEXT 里写好的、给客户看的完整说明）。
        // 不在前端按 camera/mount/size 这些原因分别硬编码一份文案——这样以后 Worker 那边
        // 新增任何原因，只要在 REASON_TEXT 里写好客户能看懂的句子，这里自动就会显示对，
        // 不需要再回来同步改前端（之前 E46 那个"尺寸太小却显示需要打孔"的文案对不上问题，根源就在这）
        box.appendChild(el('div', 'cvl-modal__title', 'This vehicle isn\'t a match.'));
        box.appendChild(noteBody(d.note || 'This vehicle is confirmed incompatible with our digital emblem.'));
        const buy = el('button', 'cvl-modal__primary', 'Order anyway'); buy.type = 'button';
        buy.addEventListener('click', () => { fit.confirmed = true; runPurchase(buy, fit, 'checkout'); });
        const wa = el('a', 'cvl-modal__secondary', 'Not sure — contact us on WhatsApp'); wa.href = 'https://wa.me/12133012742'; wa.target = '_blank'; wa.style.borderColor = '#00D9FF'; wa.style.color = '#00D9FF';
        const emailUs = el('a', 'cvl-modal__secondary', 'Email us'); emailUs.href = '/pages/contact';
        btns.append(wa, emailUs, buy);
      } else if (fit.verdict === 'invalid') {
        box.appendChild(el('div', 'cvl-modal__title', `We couldn't find "${fit.model} ${fit.year}" in our system.`));
        box.appendChild(el('div', 'cvl-modal__body', 'Please double-check your BMW model and year — or continue and our team will verify before shipping.'));
        const buy = el('button', 'cvl-modal__primary', 'Order anyway'); buy.type = 'button';
        buy.addEventListener('click', () => { fit.confirmed = true; runPurchase(buy, fit, 'checkout'); });
        const wa = el('a', 'cvl-modal__secondary', 'Not sure — contact us on WhatsApp'); wa.href = 'https://wa.me/12133012742'; wa.target = '_blank'; wa.style.borderColor = '#00D9FF'; wa.style.color = '#00D9FF';
        const emailUs = el('a', 'cvl-modal__secondary', 'Email us'); emailUs.href = '/pages/contact';
        btns.append(wa, emailUs, buy);
      } else {
        // Worker 返回了车身选项（options）→ 显示成可点按钮，点了直接按这个车身重新查询；
        // 没有选项（或是旧版 Worker）→ 照旧显示 note 文字
        const opts = Array.isArray(d.options) ? d.options.filter((o) => o && o.label && o.query) : [];
        if (opts.length && m && m.recheck) {
          box.appendChild(el('div', 'cvl-modal__title', 'Which body style is yours?'));
          if (d.options_intro || d.note) box.appendChild(noteBody(d.options_intro || d.note));
          const list = el('div', 'cvl-fit-options');
          opts.forEach((o) => {
            const b = el('button', 'cvl-fit-option', o.label); b.type = 'button';
            b.addEventListener('click', () => m.recheck(o.query, fit.year));
            list.appendChild(b);
          });
          box.appendChild(list);
        } else {
          box.appendChild(el('div', 'cvl-modal__title', 'We need to double-check this.'));
          box.appendChild(noteBody(d.note || 'We couldn\'t confirm this automatically. You can order now and we\'ll verify before shipping, or contact support first if you\'d rather check beforehand.'));
        }
        const buy = el('button', 'cvl-modal__primary', 'Order anyway'); buy.type = 'button';
        buy.addEventListener('click', () => { fit.confirmed = true; runPurchase(buy, fit, 'checkout'); });
        const wa = el('a', 'cvl-modal__secondary', 'Not sure — contact us on WhatsApp'); wa.href = 'https://wa.me/12133012742'; wa.target = '_blank'; wa.style.borderColor = '#00D9FF'; wa.style.color = '#00D9FF';
        const emailUs = el('a', 'cvl-modal__secondary', 'Email us'); emailUs.href = '/pages/contact';
        btns.append(wa, emailUs, buy);
      }
      box.appendChild(btns);
      return box;
    };

    /* --- 购买 / 加购 --- */
    // 自查勾选结果 → 订单备注 / Sheets 用的简短英文。只对带 install_check 的车型（摄像头/开箱按钮/底座没确认）有意义
    const selfCheckShort = (t) => /camera/i.test(t) ? 'no camera' : /base/i.test(t) ? 'no raised base' : /trunk/i.test(t) ? 'no trunk button' : t;
    const selfCheckSummary = (fit) => {
      // 新版 Worker：按 order.checklist 给的写法
      const tpl = fit && fit.data && fit.data.order && fit.data.order.checklist;
      if (tpl) {
        const sc = fit.selfCheck;
        if (!sc || !sc.length) return tpl.notViewed || '';
        const ticked = sc.filter((x) => x.checked);
        const fill = (t) => String(t || '').replace(/\{ticked\}/g, ticked.length).replace(/\{total\}/g, sc.length)
          .replace(/\{confirmed\}/g, ticked.map((x) => x.short || x.item).join(', ')).replace(/\{unticked\}/g, sc.filter((x) => !x.checked).map((x) => x.short || x.item).join(', '));
        return fill(ticked.length === sc.length ? tpl.all : tpl.partial);
      }
      if (fit && fit.data && fit.data.order) return '';
      if (!fit || !fit.data || !fit.data.install_check) return '';
      const sc = fit.selfCheck;
      if (!sc || !sc.length) return 'Self-check NOT viewed (bought without opening fit result) - CS to confirm camera/trunk button/base';
      const ticked = sc.filter((x) => x.checked).length;
      if (ticked === sc.length) return `Self-check ${ticked}/${sc.length} ticked (customer confirmed ${sc.map((x) => selfCheckShort(x.item)).join(', ')})`;
      return `Self-check ${ticked}/${sc.length} ticked - NOT ticked: ${sc.filter((x) => !x.checked).map((x) => selfCheckShort(x.item)).join(', ')} - CS to confirm`;
    };
    const runPurchase = async (button, vehicle, mode, sizeConfirmed = false) => {
      if (adding) return false;
      if (sizePicker && !sizeConfirmed) { openSizeDialog(button, vehicle, mode); return false; }
      if (sizePicker && !chosenVariant) return false;
      const purchaseVariantId = chosenVariant || page.dataset.variantId;
      const isEmailOffer = button.hasAttribute('data-cvl-offer-buy');
      const discountCode = isEmailOffer ? (button.dataset.cvlOfferCode || '').trim() : pageDiscountCode;
      adding = true;
      const face = button.querySelector('.cvl-btn__face') || button;
      const original = face.textContent;
      const busy = (t) => { face.textContent = t; button.disabled = true; button.classList.add('is-checking'); };
      const reset = () => { adding = false; face.textContent = original; button.disabled = false; button.classList.remove('is-checking'); };
      const model = vehicle?.model || '', year = vehicle?.year || '', hasVehicle = Boolean(model && year);
      let productAdded = false;
      const errorHost = button.closest('.cvl-modal') || button.closest('.cvl-hero__cta, .cvl-preorder__box, [data-cvl-sticky]') || button.parentElement;
      errorHost?.querySelector('.cvl-form__error')?.classList.remove('is-on');
      try {
        let fitmentNote = '';
        if (!hasVehicle) {
          fitmentNote = 'Vehicle not provided | CS to confirm model & year before shipping';
        } else {
          busy('Checking fit…');
          const fit = await fetchFitment(model, year);
          fitmentNote = fit.note;
          // 购买不拦截（2026-09-24 用户决定）：检测结果只写进订单备注和检测记录，客服在下单后跟进；
          // 兼容性提示走独立的「Check it fits your BMW」按钮，不在购买流程里弹任何窗
          const ord = fit.data && fit.data.order;
          if (ord) fitmentNote += (fit.confirmed ? ord.ifConfirmed : ord.ifNotConfirmed) || ''; // 新版 Worker 给好的写法
          else if (fit.confirmed) {
            if (fit.verdict === 'do_not_ship') fitmentNote += ` | Customer self-confirmed despite ${fit.data.do_not_ship_reason || 'incompatibility'} warning`;
            else if (fit.verdict === 'check') fitmentNote += ' | Customer self-confirmed';
          } else if (fit.verdict === 'do_not_ship') fitmentNote += ` | Incompatible (${fit.data.do_not_ship_reason || 'unknown reason'}) - CS to confirm before shipping`; // 按实际原因写（camera / mount / size），不再把尺寸问题写成 Mount warning
          else if (fit.verdict === 'invalid') fitmentNote += ' | Vehicle not found - CS to confirm before shipping';
          else if (fit.verdict === 'check') fitmentNote += ' | Needs manual check - CS to confirm before shipping';
          const sc = selfCheckSummary(fit); if (sc) fitmentNote += ` | ${sc}`;
          // Session ID 写进订单备注：Worker 的 /webhook 靠它把订单号回填到 Google Sheets 对应行
          fitmentNote += ` | Session: ${sessionId()}`;
        }
        if (orderTag) fitmentNote += ` | ${orderTag}`;
        fitmentNote += utmNote();
        busy('Adding…');
        const properties = {};
        if (isEmailOffer) properties['_cvl_email_offer'] = discountCode;
        if (model) properties['BMW Model'] = model;
        if (year) properties['Model Year'] = year;
        if (!hasVehicle) properties['Vehicle'] = 'Not provided - CS to confirm';
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: Number(purchaseVariantId), quantity: 1, properties }) });
        if (!response.ok) throw new Error('Unable to add product');
        productAdded = true;
        const added = await response.json().catch(() => ({}));
        if (hasVehicle && lastFit && lastFit.model === model && lastFit.year === year) recordFit(endpoint, lastFit, lastFit.verdict === 'ship' ? FIT_STATUS.orderedOk : FIT_STATUS.orderedBad, (lastFit.data && lastFit.data.order)
          ? [(lastFit.confirmed ? lastFit.data.order.sheetIfConfirmed : lastFit.data.order.sheetIfNotConfirmed) || '', selfCheckSummary(lastFit)].filter(Boolean).join(' | ')
          : lastFit.verdict === 'ship' ? selfCheckSummary(lastFit) : (lastFit.confirmed ? 'Customer self-confirmed' : 'Ordered without confirmation - CS to follow up'));
        if (mode === 'cart' && discountCode) {
          // Apply the lucky-page code before rendering the drawer. Bundle the updated
          // sections with the note/discount request so totals come from Shopify.
          const sections = ['variant-added'];
          document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
          const updated = await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: fitmentNote, discount: discountCode, sections: [...new Set(sections)].slice(0, 5), sections_url: `${root}variants/${purchaseVariantId}` }) });
          if (!updated.ok) throw new Error('Unable to apply discount');
          const cart = await updated.json();
          const applied = cart.discount_codes?.some((code) => code.applicable && code.code.toLowerCase() === discountCode.toLowerCase());
          if (!applied) throw new Error('Discount not applicable');
          // A missing bundled section should fall back to the cart page, rather than
          // opening a notification with stale prices or issuing another Ajax request.
          if (window.themeVariables?.settings.cartType === 'page' || sections.some((id) => !cart.sections?.[id])) {
            window.location.assign(`${root}cart`);
          } else {
            document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart } }));
            document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [added], cart } }));
          }
          return true;
        }
        await fetch(`${root}cart/update.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: fitmentNote }) }).catch(() => {});
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        if (mode === 'cart') {
          const cart = await fetch(`${root}cart.js`).then((r) => r.json()).catch(() => null);
          setTimeout(() => document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: [added], cart } })), 350);
          reset(); face.textContent = 'Added ✓'; setTimeout(() => { face.textContent = original; }, 1800);
          return true;
        }
        window.location.assign(discountCode ? `${root}discount/${encodeURIComponent(discountCode)}?redirect=${encodeURIComponent(root + 'checkout')}` : `${root}checkout`);
      } catch (e) {
        reset();
        const host = errorHost;
        let err = host?.querySelector('.cvl-form__error');
        if (!err && host) { err = el('p', 'cvl-form__error'); host.appendChild(err); }
        if (err) {
          err.textContent = productAdded && mode === 'cart' && discountCode
            ? page.dataset.discountFailureMessage
            : 'Something went wrong adding this to your cart. Please try again.';
          err.setAttribute('role', 'alert'); err.classList.add('is-on');
        }
        return false;
      } finally {
        reset();
      }
    };
    const currentVehicle = (button) => {
      const form = button.closest('section')?.querySelector('[data-cvl-vehicle-form]') || page.querySelector('[data-cvl-vehicle-form]');
      if (form && !modalTpl) {
        const model = form.querySelector('[data-cvl-model]')?.value.trim() || '', year = form.querySelector('[data-cvl-year]')?.value.trim() || '';
        if (model && year) return validVehicle(form);
        return {};
      }
      const v = readVehicle(); return v.model && v.year ? v : {};
    };
    page.querySelectorAll('[data-cvl-add]').forEach((button) => {
      button.addEventListener('click', () => { if (adding) return; const v = currentVehicle(button); if (v) runPurchase(button, v, button.hasAttribute('data-cvl-add-only') ? 'cart' : 'checkout'); });
    });
    page.querySelectorAll('[data-cvl-check-fit]').forEach((b) => { b.dataset.label = b.textContent; b.addEventListener('click', openFitCheck); });
  };

  /* ---------- 幸运页附加：倒计时 + 手机底部常驻购买条 ---------- */
  const prepareLucky = (page) => {
    page.querySelectorAll('[data-cvl-countdown]').forEach((node) => {
      const out = node.querySelector('b'); if (!out) return;
      let end = Date.parse(node.dataset.ends || '');
      if (!end) {
        const hours = Number(node.dataset.hours) || 0; if (!hours) return;
        const key = `cvl-lucky-ends:${node.dataset.key || 'default'}`;
        try {
          end = Number(localStorage.getItem(key)) || 0;
          if (!end) { end = Date.now() + hours * 36e5; localStorage.setItem(key, String(end)); }
        } catch (e) { end = Date.now() + hours * 36e5; }
      }
      if (!end) return;
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const left = end - Date.now();
        if (left <= 0) { node.hidden = true; clearInterval(timer); return; }
        const d = Math.floor(left / 864e5), h = Math.floor(left % 864e5 / 36e5), m = Math.floor(left % 36e5 / 6e4), s = Math.floor(left % 6e4 / 1e3);
        out.textContent = (d ? `${d}d ` : '') + `${pad(h)}:${pad(m)}:${pad(s)}`; node.hidden = false;
      };
      const timer = setInterval(tick, 1000); tick();
    });
    const bar = page.querySelector('[data-cvl-sticky]'); const anchor = page.querySelector('#cvl-price-row'); const box = page.querySelector('.cvl-preorder__box');
    if (!bar || !anchor) return;
    let pastHero = false, boxVisible = false;
    const update = () => bar.classList.toggle('is-on', pastHero && !boxVisible);
    new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; update(); }).observe(anchor);
    if (box) new IntersectionObserver(([e]) => { boxVisible = e.isIntersecting; update(); }, { threshold: 0.2 }).observe(box);
  };

  const ENTER_MAX_WAIT_MS = 2200;
  const STRIKE = { delayMs: 1500, life: 0.42, speed: 1500, angleDeg: 58, tail: 300, sparks: 26 };
  const strike = (page) => {
    if (page.classList.contains('cvl--struck')) return;
    const hit = () => { page.classList.add('cvl--struck'); page.dispatchEvent(new CustomEvent('cvl:struck')); };
    if (reduced()) return hit();
    const inView = (r) => r.width > 0 && r.top > 0 && r.bottom < innerHeight;
    let r = page.querySelector('.cvl-lucky__pre')?.getBoundingClientRect();
    if (!r || !inView(r)) r = page.querySelector('.cvl-badge')?.getBoundingClientRect();
    if (!r) return hit();
    const x = r.left + r.width * 0.45, y = r.top + r.height * 0.5;
    page.dispatchEvent(new CustomEvent('cvl:aim', { detail: { x, y, life: STRIKE.life } }));
    setTimeout(() => {
      hit();
      const flash = document.createElement('div'); flash.className = 'cvl-lucky__flash'; flash.setAttribute('aria-hidden', 'true');
      const sparks = document.createElement('div'); sparks.className = 'cvl-lucky__sparks'; sparks.setAttribute('aria-hidden', 'true');
      for (const el of [flash, sparks]) { el.style.setProperty('--hx', x + 'px'); el.style.setProperty('--hy', y + 'px'); }
      for (let i = 0; i < STRIKE.sparks; i++) {
        const a = rand(0, Math.PI * 2), d = rand(60, 220), dot = document.createElement('i');
        dot.style.setProperty('--dx', Math.cos(a) * d + 'px'); dot.style.setProperty('--dy', Math.sin(a) * d + 30 + 'px');
        dot.style.setProperty('--s', rand(3, 7) + 'px'); dot.style.setProperty('--t', rand(0.8, 1.4) + 's');
        sparks.appendChild(dot);
      }
      document.body.append(flash, sparks);
      setTimeout(() => { flash.remove(); sparks.remove(); }, 1600);
    }, STRIKE.life * 1000);
  };
  const init = (root) => {
    const page = root.matches?.('[data-cvl-page]') ? root : root.querySelector?.('[data-cvl-page]');
    if (!page || page.dataset.cvlReady) return;
    page.dataset.cvlReady = '1';
    page.classList.add('cvl-js');
    injectFitLoadingStyles();
    prepareReveals(page); removeUpstreamPayPal(page);
    const badgeReady = prepareBadge(page);
    prepareCarousels(page); prepareFloat(page); prepareVideos(page); prepareSeries(page); prepareFit(page); prepareVehicleForms(page); prepareCart(page); prepareLucky(page);
    startSky(page);
    Promise.race([badgeReady, new Promise((res) => setTimeout(res, ENTER_MAX_WAIT_MS))]).then(() => {
      page.classList.add('cvl--enter'); page.dispatchEvent(new CustomEvent('cvl:enter'));
      if (page.classList.contains('cvl--founding')) setTimeout(() => strike(page), STRIKE.delayMs);
    });
  };
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document)); else init(document);
})();